import { useContext } from 'react'

import { ValidationProviderContext } from '../context'

export const useValidationProvider = () => useContext(ValidationProviderContext)
